import { useState, useEffect } from "react"
import { useLocation, useNavigate, useOutletContext, useSearchParams } from "react-router-dom"
import lodash from "lodash"
import deepdash from "deepdash"
import { lang } from "config"
import Input from "components/forms/input"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import AddProduct from "./add-product"
import { useResultSet } from "repositories/db-repository"
import DeleteProduct from "./delete-product"
import { useAuth } from "contexts/auth-context"
import { getIsAdmin, getIsSupervisor, getIsOwner } from "helpers/general-helper"
import { getParameter } from "helpers/general-helper"
import useUserByRoleBranch from "repositories/user-by-role-branch"
import SelectSearchable from "components/forms/select-searchable"
import { getGenericSupplier } from "helpers/general-helper"
import ErrorMessage from "components/forms/error-message"
import generateBill from "repositories/generate-bill"
import { sendViaWA } from "helpers/general-helper"
import useBranchesByUser from "repositories/branch-by-user"
import { getBranchList } from "helpers/general-helper"

export default function Form({ data, errors, onSubmit }) {
    const _ = deepdash(lodash)
    
    const { can, user, isSuper, currentBranch, setCurrentBranch } = useAuth()
    const isLoadingItem = false
    const { setTitle } = useOutletContext()
    const navigate = useNavigate()
 
    // Transition
    const { title, transition, setTransition } = useOutletContext()
    // React router location hook
    const location = useLocation()

    const [searchParams, setSearchParams] = useSearchParams()
    const search = searchParams.get('search')

    // const { data: branchSelection } = useBranchesByUser({
    //     is_super: isSuper(),
    //     user_id: user?.id
    // })
    const branchSelection = getBranchList()
    const supplierSelection = getGenericSupplier()
    
    const [id, set_id] = useState(data?.purchase_transaction?.id ?? null);
    const [outlet_group_id, set_outlet_group_id] = useState(data?.purchase_transaction?.outlet_group_id ?? getParameter("OUTLET_GROUP_ID") ?? null);
    const [outlet_id, set_outlet_id] = useState(data?.purchase_transaction?.outlet_id ?? currentBranch?.id ?? null);
    const remax_hq_outlet_id = getParameter("REMAX_HQ_OUTLET_ID")
    const { data: productUnitSelection, isLoading, mutate } = 
        useResultSet(`${process.env.REACT_APP_INVENTORY_API_URL}`, `ps_list`, 
        { outlet_group_id: outlet_group_id, outlet_id: remax_hq_outlet_id})

    const [outlet_group_name, set_outlet_group_name] = useState(data?.purchase_transaction?.outlet_group_name ?? getParameter("OUTLET_GROUP_NAME") ?? null);
    const [outlet_group_phone_number, set_outlet_group_phone_number] = useState(data?.purchase_transaction?.outlet_group_phone_number ?? getParameter("OUTLET_GROUP_PHONE_NUMBER") ?? null);
    const [outlet_group_email_address, set_outlet_group_email_address] = useState(data?.purchase_transaction?.outlet_group_email_address ?? null);
    const [public_id, set_public_id] = useState(data?.purchase_transaction?.public_id ?? null);
    const [user_id, set_user_id] = useState(data?.purchase_transaction?.user_id ?? user?.id ?? null);
    const [user_name, set_user_name] = useState(data?.purchase_transaction?.user_name ?? user?.name ?? null);
    const [outlet_name, set_outlet_name] = useState(data?.purchase_transaction?.outlet_name ?? currentBranch?.name ?? null);
    const [outlet_phone_number, set_outlet_phone_number] = useState(data?.purchase_transaction?.outlet_phone_number ?? currentBranch?.contact ?? null);
    const [outlet_email_address, set_outlet_email_address] = useState(data?.purchase_transaction?.outlet_email_address ?? null);
    const [entry_date, set_entry_date] = useState(data?.purchase_transaction?.entry_date ?? null);
    const [latest_flow_detail_id, set_latest_flow_detail_id] = useState(data?.purchase_transaction?.latest_flow_detail_id ?? "PURCHASE_REQUEST_DRAFT");

    // const origin = (data?.purchase_transaction?.latest_flow_detail_id == "SALES_ORDER_DELIVERY_ON_GOING" ||
    // data?.purchase_transaction?.latest_flow_detail_id == "SALES_ORDER_DELIVERY_RETURN" ||
    // data?.purchase_transaction?.latest_flow_detail_id == "SALES_ORDER_BILL_RTN_CREATED" ||
    // data?.purchase_transaction?.latest_flow_detail_id == "SALES_ORDER_CLOSED" ||
    // data?.purchase_transaction?.latest_flow_detail_id == "SALES_ORDER_BILL_PO_CREATED" ||
    // data?.purchase_transaction?.latest_flow_detail_id == "SALES_ORDER_COMPLETED") ? "RS" : 
    // (data?.purchase_transaction?.latest_flow_detail_id == "SALES_ORDER_APPROVED" ||
    // data?.purchase_transaction?.latest_flow_detail_id == "SALES_ORDER_BILL_CREATED" ||
    // data?.purchase_transaction?.latest_flow_detail_id == "SALES_ORDER_WILL_DELIVER") ? "DS" :
    // (data?.purchase_transaction?.latest_flow_detail_id.substring(0, 5) == "SALES") ? "SS" : "PS";

    const origin = 'PS';
    
    const selectedPurchaseHeader = data?.purchase_header?.find((row) => row.origin === origin);

    const [purchase_header_id, set_purchase_header_id] = useState(selectedPurchaseHeader?.id ?? null);
    const [purchase_transaction_id, set_purchase_transaction_id] = useState(selectedPurchaseHeader?.purchase_transaction_id ?? data?.purchase_transaction?.id ?? null);
    const [warehouse_id, set_warehouse_id] = useState(selectedPurchaseHeader?.warehouse_id ?? currentBranch?.id ?? null);
    const [warehouse_name, set_warehouse_name] = useState(selectedPurchaseHeader?.warehouse_name ?? currentBranch?.name ?? null);
    const [warehouse_address, set_warehouse_address] = useState(selectedPurchaseHeader?.warehouse_address ?? currentBranch?.address ?? null);
    const [supplier_id, set_supplier_id] = useState(selectedPurchaseHeader?.supplier_id ?? null);
    const [supplier_name, set_supplier_name] = useState(selectedPurchaseHeader?.supplier_name ?? null);
    const [supplier_phone_number, set_supplier_phone_number] = useState(selectedPurchaseHeader?.supplier_phone_number ?? null);
    const [supplier_email_address, set_supplier_email_address] = useState(selectedPurchaseHeader?.supplier_email_address ?? null);
    const [supplier_address, set_supplier_address] = useState(selectedPurchaseHeader?.supplier_address ?? null);
    const [notes, set_notes] = useState(selectedPurchaseHeader?.notes ?? null);
    const [flow_detail_id, set_flow_detail_id] = useState(selectedPurchaseHeader?.flow_detail_id ?? "PURCHASE_REQUEST_DRAFT");
    const [currency_id, set_currency_id] = useState(selectedPurchaseHeader?.currency_id ?? "IDR");
    const [rate, set_rate] = useState(selectedPurchaseHeader?.rate ?? 1);
    const [po_amount, set_po_amount] = useState(data?.purchase_header_side_by_side?.po_amount ?? null);
    const [so_amount, set_so_amount] = useState(data?.purchase_header_side_by_side?.so_amount ?? null);
    const [dlv_amount, set_dlv_amount] = useState(data?.purchase_header_side_by_side?.dlv_amount ?? null);
    const [rcv_amount, set_rcv_amount] = useState(data?.purchase_header_side_by_side?.rcv_amount ?? null);
    const [rtn_amount, set_rtn_amount] = useState(data?.purchase_header_side_by_side?.rtn_amount ?? null);

    const [po_discount_amount, set_po_discount_amount] = useState(data?.purchase_header_side_by_side?.po_discount_amount ?? null);
    const [so_discount_amount, set_so_discount_amount] = useState(data?.purchase_header_side_by_side?.so_discount_amount ?? null);
    const [dlv_discount_amount, set_dlv_discount_amount] = useState(data?.purchase_header_side_by_side?.dlv_discount_amount ?? null);
    const [rcv_discount_amount, set_rcv_discount_amount] = useState(data?.purchase_header_side_by_side?.rcv_discount_amount ?? null);
    const [rtn_discount_amount, set_rtn_discount_amount] = useState(data?.purchase_header_side_by_side?.rtn_discount_amount ?? null);
    
    const [po_nett_amount, set_po_nett_amount] = useState(data?.purchase_header_side_by_side?.po_nett_amount ?? null);
    const [so_nett_amount, set_so_nett_amount] = useState(data?.purchase_header_side_by_side?.so_nett_amount ?? null);
    const [dlv_nett_amount, set_dlv_nett_amount] = useState(data?.purchase_header_side_by_side?.dlv_nett_amount ?? null);
    const [rcv_nett_amount, set_rcv_nett_amount] = useState(data?.purchase_header_side_by_side?.rcv_nett_amount ?? null);
    const [rtn_nett_amount, set_rtn_nett_amount] = useState(data?.purchase_header_side_by_side?.rtn_nett_amount ?? null);
    const [ppn_percentage, set_ppn_percentage] = useState(selectedPurchaseHeader?.ppn_percentage ?? null);

    const is_admin = getIsAdmin()
    const is_supervisor = getIsSupervisor()
    const is_owner = getIsOwner()
    const url_web_purchase = getParameter("URL_WEB_PURCHASE")

    const { data: supervisorSelection } = useUserByRoleBranch({
        permission: 'purchase.approve', 
        branch: currentBranch?.id
    })
    const { data: ownerSelection } = useUserByRoleBranch({ 
        permission: 'purchase.send', 
        branch: currentBranch?.id
    })

    const arr_purchase = {id, origin, outlet_group_id, outlet_group_name, outlet_group_phone_number, 
        outlet_group_email_address, public_id, purchase_header_id, user_id, user_name, outlet_id, outlet_name,  
        outlet_phone_number, outlet_email_address, entry_date, warehouse_id, warehouse_name, warehouse_address, 
        supplier_id, supplier_name, supplier_phone_number, supplier_email_address, supplier_address, 
        notes, currency_id, rate, ppn_percentage};

    const set_notes_all = (value) => {
        set_notes(value)
        if (selectedPurchaseHeader !== undefined) {
            selectedPurchaseHeader.notes = value
        }
        const tsPurchaseHeader = data?.purchase_header?.find((row) => row.origin === "TS");
        if (tsPurchaseHeader !== undefined) {
            tsPurchaseHeader.notes = value
        }
    }

    const set_warehouse_name_all = (value) => {
        set_warehouse_name(value)
        if (selectedPurchaseHeader !== undefined) {
            selectedPurchaseHeader.warehouse_name = value
        }
        const tsPurchaseHeader = data?.purchase_header?.find((row) => row.origin === "TS");
        if (tsPurchaseHeader !== undefined) {
            tsPurchaseHeader.warehouse_name = value
        }
    }

    const set_warehouse_address_all = (value) => {
        set_warehouse_address(value)
        if (selectedPurchaseHeader !== undefined) {
            selectedPurchaseHeader.warehouse_address = value
        }
        const tsPurchaseHeader = data?.purchase_header?.find((row) => row.origin === "TS");
        if (tsPurchaseHeader !== undefined) {
            tsPurchaseHeader.warehouse_address = value
        }
    }

    useEffect(() => {
    }, [productUnitSelection, supervisorSelection, ownerSelection, supplierSelection, branchSelection])

    const handleSubmit = () => {
        if (!nProgress.isStarted()) {
            if(supplier_id == null || warehouse_id == null || outlet_id == null) {
                toast.error("Data Purchase tidak lengkap")
                return
            }
            // console.log({...arr_purchase,
            //     flow_detail_id, latest_flow_detail_id                
            // })
            onSubmit({...arr_purchase,
                flow_detail_id, latest_flow_detail_id                
            })
        } else {
            toast.error("Previous action is loading")
        }
    }

    const sendtoReviewer = async () => {
        if (checkAvailabilityItem() == 1) {
            if (supervisorSelection) {
                for (var i = 0; i < supervisorSelection.length; i++) {
                    await sendViaWA(supervisorSelection[i].phone, "Ada Purchase Request dari Outlet " + 
                    outlet_name + 
                    " yang harus Anda review, nomornya adalah: " + id + " click link berikut: " +
                    "\n\n" + "Link ke web PO: " + url_web_purchase)
                }
            }
            onSubmit({...arr_purchase,
                flow_detail_id: "PURCHASE_REQUEST_NEED_REVIEW", latest_flow_detail_id: "PURCHASE_REQUEST_NEED_REVIEW",
                message: "Send to reviewer berhasil!"
            })
        } else {
            toast.error("Proses tidak bisa dilanjutkan, ada PO Quantity yang lebih besar dari Supplier Stock!")
        }
    }

    const rejectPurchaseRequest = () => {
        onSubmit({...arr_purchase,
            flow_detail_id: "PURCHASE_REQUEST_REJECTED", latest_flow_detail_id: "PURCHASE_REQUEST_REJECTED",
            message: "Reject Purchase Request berhasil!"
        })
    }

    const approvePurchaseRequest = async () => {
        if (checkAvailabilityItem() == 1) {
            if (ownerSelection) {
                for (var i = 0; i < ownerSelection.length; i++) {
                    await sendViaWA(ownerSelection[i].phone, "Ada Purchase Order dari Outlet " + 
                    outlet_name + 
                    " yang harus Anda review, nomornya adalah: " + id + " click link berikut: " +
                    "\n\n" + "Link ke web PO: " + url_web_purchase)
                }
            }
            onSubmit({...arr_purchase,
                flow_detail_id: "PURCHASE_REQUEST_APPROVED", latest_flow_detail_id: "PURCHASE_REQUEST_APPROVED",
                message: "Approve Purchase Request berhasil!"
            })
        } else {
            toast.error("Proses tidak bisa dilanjutkan, ada PO Quantity yang lebih besar dari Supplier Stock!")
        }
    }

    const sendReceivedStatusToSupplier = () => {
        const tmpCheckReceivedItem = checkReceivedItem()
        if (tmpCheckReceivedItem > 1) {
            onSubmit({...arr_purchase,
                flow_detail_id: "SALES_ORDER_DELIVERY_RETURN", latest_flow_detail_id: "SALES_ORDER_DELIVERY_RETURN",
                arr_purchase_header: data?.purchase_header?.length > 0 ? JSON.stringify(data?.purchase_header) : null,
                arr_purchase_item: data?.purchase_item?.length > 0 ? JSON.stringify(data?.purchase_item) : null,
                message: "Sales Order ada yang retur, sudah diinfokan ke supplier!"
            })
        } else if (tmpCheckReceivedItem == 1) {
            console.log(arr_purchase,JSON.stringify(data?.purchase_header),JSON.stringify(data?.purchase_item))
            // onSubmit({...arr_purchase,
            //     flow_detail_id: "SALES_ORDER_CLOSED", latest_flow_detail_id: "SALES_ORDER_CLOSED",
            //     arr_purchase_header: data?.purchase_header?.length > 0 ? JSON.stringify(data?.purchase_header) : null,
            //     arr_purchase_item: data?.purchase_item?.length > 0 ? JSON.stringify(data?.purchase_item) : null,
            //     message: "Sales Order Delivery Received berhasil diinfokan ke supplier, status menjadi SALES_ORDER_CLOSED karena tidak ada barang yang diretur!"
            // })
        } else {
            toast.error("Proses tidak bisa dilanjutkan, ada RCV + RTN Quantity kurang dari DLV Quantity!")
        }
    }

    const processDataToInventory = async() => {
        const receivedPurchaseHeader = data?.purchase_header?.find((row) => row.origin === "PS");
        const receivedPurchaseItem = data?.purchase_item_group_by_origin?.filter((row) => row.origin === "PS");

        // alert(JSON.stringify(receivedPurchaseHeader))
        // alert(receivedPurchaseHeader?.length)
        const result = await generateBill({...selectedPurchaseHeader, id, outlet_id, outlet_name,  
            outlet_phone_number, outlet_group_name}, selectedPurchaseHeader, user)

        onSubmit({...arr_purchase,
            flow_detail_id: "SALES_ORDER_COMPLETED", latest_flow_detail_id: "SALES_ORDER_COMPLETED",
            arr_purchase_header: JSON.stringify(receivedPurchaseHeader),
            arr_purchase_item: JSON.stringify(receivedPurchaseItem),
            message: "Purchase Order berhasil dimasukkan ke Inventory!"
        })
    }

    const rejectPurchaseOrder = () => {
        onSubmit({...arr_purchase,
            flow_detail_id: "PURCHASE_ORDER_REJECTED", latest_flow_detail_id: "PURCHASE_ORDER_REJECTED",
            message: "Reject Purchase Order berhasil!"
        })
    }

    const sendToSupplier = () => {
        if (checkAvailabilityItem() == 1) {
            const psPurchaseHeader = data?.purchase_header?.find((row) => row.origin === "PS");
            // console.log(arr_purchase,JSON.stringify(psPurchaseHeader),JSON.stringify(data?.purchase_item),"PSS")
            onSubmit({...arr_purchase,
                flow_detail_id: "SALES_ORDER_CLOSED", latest_flow_detail_id: "SALES_ORDER_CLOSED",
                arr_purchase_header: JSON.stringify(psPurchaseHeader) ?? null,
                arr_purchase_item: data?.purchase_item?.length > 0 ? JSON.stringify(data?.purchase_item) : null,
                message: "Purchase Order Send to Supplier berhasil!"
            })
        } else {
            toast.error("Proses tidak bisa dilanjutkan, ada PO Quantity yang lebih besar dari Supplier Stock!")
        }
    }

    const checkAvailabilityItem = () => {
        if (data?.purchase_item_side_by_side?.length > 0) {
            for (var i = 0; i < data?.purchase_item_side_by_side?.length; i++) {
                var row = data?.purchase_item_side_by_side[i]
                if (row.po_quantity > row.current_stock && row.pre_order == 0) {
                    return 1
                }
            }
        }
        return 1
    }

    const checkReceivedItem = () => {
        // alert(JSON.stringify(data?.purchase_item_side_by_side))
        var returnQty = 0
        if (data?.purchase_item_side_by_side?.length > 0) {
            for (var i = 0; i < data?.purchase_item_side_by_side?.length; i++) {
                var row = data?.purchase_item_side_by_side[i]
                returnQty += row.rtn_quantity
                if (row.rcv_quantity + row.rtn_quantity < row.dlv_quantity) {
                     return 0
                }
            }
        }
        return 1 + returnQty
    }

    const executeGenerateBillPO = async () => {
        const selectedPurchaseHeader = data?.purchase_header?.find((row) => row.origin === "PS");
        const result = await generateBill({...selectedPurchaseHeader, id, outlet_id, outlet_name,  
            outlet_phone_number, outlet_group_name}, selectedPurchaseHeader, user)

        if (result === true) {
            onSubmit({...arr_purchase,
                flow_detail_id: "SALES_ORDER_BILL_PO_CREATED", latest_flow_detail_id: "SALES_ORDER_BILL_PO_CREATED",
                arr_purchase_item: data?.purchase_item?.length > 0 ? JSON.stringify(data?.purchase_item) : null,
                message: "Bill PO untuk Purchase Order ini sudah dibuat!"
            })
        } else {
            // toast.error("Proses Create Bill gagal!")
        }
    }

    // 1) Helper ambil header & items dari state 'data' (punyamu sudah ada)
    const buildPOHeaderPayload = () => {
    const h = data?.purchase_header?.find(row => row.origin === "PS");
    return {
        id: h?.id ?? purchase_header_id ?? null,
        origin: "PS",
        date: entry_date, // pastikan format 'YYYY-MM-DD HH:mm:ss' dari backend
        supplier: {
        id: h?.supplier_id ?? supplier_id ?? null,
        name: h?.supplier_name ?? supplier_name ?? null,
        phone: h?.supplier_phone_number ?? supplier_phone_number ?? null,
        email: h?.supplier_email_address ?? supplier_email_address ?? null,
        address: h?.supplier_address ?? supplier_address ?? null,
        },
        ship_to: {
        warehouse_id: h?.warehouse_id ?? warehouse_id ?? null,
        warehouse_name: h?.warehouse_name ?? warehouse_name ?? null,
        warehouse_address: h?.warehouse_address ?? warehouse_address ?? null,
        },
        outlet: {
        id: outlet_id ?? null,
        name: outlet_name ?? null,
        group_name: outlet_group_name ?? null,
        },
        ppn_percentage: h?.ppn_percentage ?? ppn_percentage ?? null,
        notes: h?.notes ?? notes ?? "",
    };
    };

    const buildPOItemsPayload = () => {
    const rows = data?.purchase_item_side_by_side ?? [];
    return rows.map((r, i) => ({
        no: i + 1,
        type: r.item_type === "GA" ? "Give Away" : "Order",
        product_unit: r.product_unit,
        qty: r.po_quantity,
        price: r.po_price,
        total_amount: r.po_total_amount,
        total_discount: r.po_total_discount,
        total_nett: r.po_total_nett,
        remark: r.notes ?? ""
    }));
    };

    // 2) Function nembak API print dan buka PDF
    const printPOViaAPI = async () => {
    try {
        if (!data?.purchase_item?.length) {
        toast.error("Tidak ada item PO untuk dicetak.");
        return;
        }
        nProgress.start();

        const payload = {
        purchase_transaction_id: id ?? data?.purchase_transaction?.id ?? null,
        purchase_header: buildPOHeaderPayload(),
        purchase_items: buildPOItemsPayload(),
        meta: {
            printed_by: user?.name ?? "System",
            currency: "IDR",
            outlet_phone: outlet_phone_number ?? null,
            outlet_email: outlet_email_address ?? null
        }
        };

        const res = await fetch(`${process.env.REACT_APP_INVENTORY_API_URL}/purchase-order/print`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            // kalau pakai bearer token:
            ...(user?.token ? { "Authorization": `Bearer ${user.token}` } : {})
        },
        body: JSON.stringify(payload)
        });

        if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(`Print gagal (${res.status}) ${text}`);
        }

        // expect application/pdf
        const blob = await res.blob();
        const ct = res.headers.get("Content-Type") || "";
        if (!ct.toLowerCase().includes("pdf")) {
        // jaga-jaga bila backend balikin JSON error
        const text = await blob.text();
        throw new Error(text || "Server tidak mengembalikan PDF");
        }

        // Buka di tab baru
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");

        // Atau: auto-download (pilih salah satu)
        // const a = document.createElement("a");
        // a.href = url;
        // a.download = `PO-${payload.purchase_header.id || "document"}.pdf`;
        // a.click();
        // URL.revokeObjectURL(url);

        toast.success("PO siap dicetak.");
    } catch (e) {
        console.error(e);
        toast.error(e.message || "Gagal mencetak PO.");
    } finally {
        nProgress.done();
    }
    };


    return (
        <div className="mt-8 space-y-8">
            <div className="mt-10 sm:mt-0">
                <div className="space-y-8">
                    <div className="md:col-span-1">
                        <div className="px-4 sm:px-0">
                            <h3 className="text-lg font-medium leading-6 text-gray-900">{lang.main_form+ ' ' + origin}</h3>
                            <p className="mt-1 text-sm text-gray-600">{lang.please_fill_the_provided_form_input}</p>
                        </div>
                    </div>
                    <div className="mt-5 md:col-span-2 md:mt-0">
                        <div className="border sm:rounded-xl">
                            <div className="px-4 py-5 sm:p-6">
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label htmlFor="id" className="block text-xs text-neutral-700">{lang.purchase_number}<sup class="text-xs text-red-700"> *</sup></label>
                                        <Input placeholder="Generated by system" disabled={true} maxLength={100} value={id} id="id" error={errors.id} />
                                    </div>
                                    <div>
                                        <label htmlFor="latest_flow_detail_id" className="block text-xs text-neutral-700">{lang.status}<sup class="text-xs text-red-700"> *</sup></label>
                                        <Input placeholder="" disabled={true} maxLength={100} value={latest_flow_detail_id} id="latest_flow_detail_id" error={errors.latest_flow_detail_id} />
                                    </div>
                                    <div>
                                        <label htmlFor="user_name" className="block text-xs text-neutral-700">{lang.user_name}<sup class="text-xs text-red-700"> *</sup></label>
                                        <Input placeholder="User Name" disabled={true} maxLength={100} onChange={(e) => set_user_name(e.target.value)} value={user_name} id="user_name" error={errors.user_name} />
                                    </div>
                                    {/* <div>
                                        <label htmlFor="outlet_name" className="block text-xs text-neutral-700">{lang.outlet_name}<sup class="text-xs text-red-700"> *</sup></label>
                                        <Input placeholder="Outlet Name" disabled={true} maxLength={100} onChange={(e) => set_outlet_name(e.target.value)} value={outlet_name} id="outlet_name" error={errors.outlet_name} />
                                    </div> */}
                                    <div>
                                        <label htmlFor="outlet_name" className="block text-xs text-neutral-700">{lang.outlet_name}<sup class="text-xs text-red-700"> *</sup></label>
                                        <SelectSearchable 
                                            disabled={latest_flow_detail_id == "SALES_ORDER_COMPLETED" ? true : false}
                                            filter={(value) => value.name}
                                            onChange={(value) => {
                                                var tmp = branchSelection?.find(item => item.id == value)
                                                set_outlet_id(value)
                                                set_outlet_name(tmp?.name)
                                                set_outlet_phone_number(tmp?.contact)
                                                set_warehouse_id(tmp?.id)
                                                set_warehouse_name(tmp?.name)
                                                set_warehouse_address(selectedPurchaseHeader?.warehouse_address ?? tmp?.address)
                                            }}
                                            selection={branchSelection}
                                            isLoading={false}
                                            value={outlet_id}
                                            keyValue={(value) => value.id}
                                            title={(value) => value.name}
                                            placeholder={`-- Select Outlet --`}
                                        />
                                        <ErrorMessage error={errors.outlet_name} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="my-2 border sm:rounded-xl">
                            <div className="px-4 py-5 sm:p-6">
                                <div className="grid grid-cols-2 gap-4">
                                    
                                    <div>
                                        <label htmlFor="warehouse_name" className="block text-xs text-neutral-700">{lang.deliver_to}<sup class="text-xs text-red-700"> *</sup></label>
                                        <Input disabled={true} placeholder="Deliver to" maxLength={100} onChange={(e) => set_warehouse_name_all(e.target.value)} value={warehouse_name} id="warehouse_name" error={errors.warehouse_name} />
                                        <ErrorMessage error={errors.warehouse_name} />
                                    </div>
                                    <div>
                                        <label htmlFor="supplier_name" className="block text-xs text-neutral-700">{lang.supplier_name}<sup class="text-xs text-red-700"> *</sup></label>
                                        <SelectSearchable 
                                            disabled={latest_flow_detail_id == "SALES_ORDER_COMPLETED" ? true : false}
                                            filter={(value) => value.name}
                                            onChange={(value) => {
                                                set_supplier_id(value)
                                                var tmp = supplierSelection?.find(item => item.id == value)
                                                set_supplier_name(tmp?.name)
                                                set_supplier_phone_number(tmp?.mobile ?? tmp?.contact_number ?? tmp?.code)
                                                set_supplier_address(tmp?.address)
                                            }}
                                            selection={supplierSelection}
                                            isLoading={false}
                                            value={supplier_id}
                                            keyValue={(value) => value.id}
                                            title={(value) => value.name}
                                            placeholder={`-- Select Supplier --`}
                                        />
                                        <ErrorMessage error={errors.supplier_name} />
                                    </div>
                                    <div>
                                        <label htmlFor="warehouse_address" className="block text-xs text-neutral-700">{lang.delivery_address}<sup class="text-xs text-red-700"> *</sup></label>
                                        <textarea disabled={true} onChange={e => set_warehouse_address_all(e.target.value)} value={warehouse_address} name="warehouse_address" id="warehouse_address" rows="3" className="block w-full px-4 py-2 mt-1 text-sm transition border border-neutral-200 focus:outline-none rounded-xl focus:border-neutral-400 focus:ring focus:ring-neutral-200 disabled:bg-neutral-200"></textarea>
                                        <ErrorMessage error={errors.warehouse_address} />
                                    </div>
                                    <div>
                                        <label htmlFor="notes" className="block text-xs text-neutral-700">{lang.notes}<sup class="text-xs text-red-700"></sup></label>
                                        <textarea disabled={latest_flow_detail_id == "SALES_ORDER_COMPLETED" ? true : false} onChange={e => set_notes_all(e.target.value)} value={notes} name="notes" id="notes" rows="3" className="block w-full px-4 py-2 mt-1 text-sm transition border border-neutral-200 focus:outline-none rounded-xl focus:border-neutral-400 focus:ring focus:ring-neutral-200"></textarea>
                                        <ErrorMessage error={errors.notes} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {data?.purchase_item?.length > 0 && (
            <div className="flex justify-end space-x-2">
                <button
                type="button"
                onClick={printPOViaAPI}
                className="bg-red-800 inline-flex items-center p-2 text-white text-xs transition rounded active:hover:scale-90"
                >
                <span>Print PO</span>
                </button>
            </div>
            )}

            {data?.purchase_item?.length > 0 && 
                (latest_flow_detail_id == undefined || 
                latest_flow_detail_id == "PURCHASE_REQUEST_DRAFT" || 
                latest_flow_detail_id == "PURCHASE_REQUEST_REJECTED") && 
                is_admin == 1 && is_supervisor == 0 && is_owner == 0 && (
            <div className="flex justify-end" >
                <button type="button" disabled={false} onClick={sendtoReviewer} class={`${false ? 'opacity-50 bg-red-900' : 'bg-red-800'} inline-flex items-center p-1 text-white text-xs transition rounded active:hover:scale-90`}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M4.698 4.034l16.302 7.966l-16.302 7.966a.503 .503 0 0 1 -.546 -.124a.555 .555 0 0 1 -.12 -.568l2.468 -7.274l-2.468 -7.274a.555 .555 0 0 1 .12 -.568a.503 .503 0 0 1 .546 -.124z" />
                        <path d="M6.5 12h14.5" />
                    </svg>
                    <span>{`Send to reviewer`}</span>
                </button>
            </div>)}

            {data?.purchase_item?.length > 0 && 
                (latest_flow_detail_id == undefined || 
                    latest_flow_detail_id == "PURCHASE_REQUEST_DRAFT" || 
                    latest_flow_detail_id == "PURCHASE_REQUEST_REJECTED" ||
                    latest_flow_detail_id == "PURCHASE_REQUEST_NEED_REVIEW" || 
                    latest_flow_detail_id == "PURCHASE_REQUEST_IN_REVIEW" ||
                    latest_flow_detail_id == "PURCHASE_ORDER_REJECTED") && 
                is_supervisor == 1 && is_owner == 0 && (
            <div className="flex justify-end space-x-2" >
                {(
                <button type="button" disabled={false} onClick={rejectPurchaseRequest} class={`${'opacity-70 bg-red-800'}  inline-flex items-center p-1 text-white text-xs transition rounded active:hover:scale-90`}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                        <path d="M5.7 5.7l12.6 12.6" />
                    </svg>
                    <span>{`Reject`}</span>
                </button>)}
                <button type="button" disabled={false} onClick={approvePurchaseRequest} class={`${'bg-red-800'} inline-flex items-center p-1 text-white text-xs transition rounded active:hover:scale-90`}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                        <path d="M21 21l-6 -6" />
                        <path d="M7 10l2 2l4 -4" />
                    </svg>
                    <span>{`Approve Purchase Request`}</span>
                </button>
            </div>)}

            {data?.purchase_item?.length > 0 && 
                (latest_flow_detail_id == undefined || 
                    latest_flow_detail_id == "PURCHASE_REQUEST_DRAFT" || 
                    latest_flow_detail_id == "PURCHASE_REQUEST_REJECTED" ||
                    latest_flow_detail_id == "PURCHASE_REQUEST_NEED_REVIEW" || 
                    latest_flow_detail_id == "PURCHASE_REQUEST_IN_REVIEW" ||
                    latest_flow_detail_id == "PURCHASE_ORDER_REJECTED" ||
                    latest_flow_detail_id == "PURCHASE_REQUEST_APPROVED" || 
                    latest_flow_detail_id == "PURCHASE_ORDER_IN_REVIEW") && 
                    is_owner == 1 && (
            <div className="flex justify-end space-x-2" >
                <button type="button" disabled={false} onClick={rejectPurchaseOrder} class={`${'opacity-70 bg-red-800'}  inline-flex items-center p-1 text-white text-xs transition rounded active:hover:scale-90`}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                        <path d="M5.7 5.7l12.6 12.6" />
                    </svg>
                    <span>{`Reject`}</span>
                </button>
                <button type="button" disabled={false} onClick={sendToSupplier} class={`${'bg-red-800'} inline-flex items-center p-1 text-white text-xs transition rounded active:hover:scale-90`}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M4.698 4.034l16.302 7.966l-16.302 7.966a.503 .503 0 0 1 -.546 -.124a.555 .555 0 0 1 -.12 -.568l2.468 -7.274l-2.468 -7.274a.555 .555 0 0 1 .12 -.568a.503 .503 0 0 1 .546 -.124z" />
                        <path d="M6.5 12h14.5" />
                    </svg>
                    <span>{`Approve PO and Send to Supplier`}</span>
                </button>
            </div>)}

            {data?.purchase_item?.length > 0 && 
                ((latest_flow_detail_id == "SALES_ORDER_DELIVERY_ON_GOING" || latest_flow_detail_id == "SALES_ORDER_DELIVERY_RETURN") && (is_admin == 1 || is_supervisor == 1 || is_owner == 1))
                 && (
            <div className="flex justify-end space-x-2" >
                <button type="button" disabled={false} onClick={sendReceivedStatusToSupplier} class={`${'bg-red-800'}  inline-flex items-center p-1 text-white text-xs transition rounded active:hover:scale-90`}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M4.698 4.034l16.302 7.966l-16.302 7.966a.503 .503 0 0 1 -.546 -.124a.555 .555 0 0 1 -.12 -.568l2.468 -7.274l-2.468 -7.274a.555 .555 0 0 1 .12 -.568a.503 .503 0 0 1 .546 -.124z" />
                        <path d="M6.5 12h14.5" />
                    </svg>
                    <span>{`Send Received Status to Supplier`}</span>
                </button>
            </div>)}

            {/* {data?.purchase_item?.length > 0 && 
                ((latest_flow_detail_id == "SALES_ORDER_BILL_RTN_CREATED" ||
                latest_flow_detail_id == "SALES_ORDER_CLOSED") && (is_admin == 1 || is_supervisor == 1 || is_owner == 1))
                 && (
            <div className="flex justify-end space-x-2" >
                <button type="button" disabled={false} onClick={() => executeGenerateBillPO()} class={`${'bg-red-800'}  inline-flex items-center p-1 text-white text-xs transition rounded active:hover:scale-90`}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M4.698 4.034l16.302 7.966l-16.302 7.966a.503 .503 0 0 1 -.546 -.124a.555 .555 0 0 1 -.12 -.568l2.468 -7.274l-2.468 -7.274a.555 .555 0 0 1 .12 -.568a.503 .503 0 0 1 .546 -.124z" />
                        <path d="M6.5 12h14.5" />
                    </svg>
                    <span>{`Generate Bill PO`}</span>
                </button>
            </div>)} */}

            {data?.purchase_item?.length > 0 && 
                ((latest_flow_detail_id == "SALES_ORDER_CLOSED") && (is_admin == 1 || is_supervisor == 1 || is_owner == 1))
                 && (
            <div className="flex justify-end space-x-2" >
                <button type="button" disabled={false} onClick={processDataToInventory} class={`${'bg-red-800'}  inline-flex items-center p-1 text-white text-xs transition rounded active:hover:scale-90`}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M4.698 4.034l16.302 7.966l-16.302 7.966a.503 .503 0 0 1 -.546 -.124a.555 .555 0 0 1 -.12 -.568l2.468 -7.274l-2.468 -7.274a.555 .555 0 0 1 .12 -.568a.503 .503 0 0 1 .546 -.124z" />
                        <path d="M6.5 12h14.5" />
                    </svg>
                    <span>{`Proses Data to Inventory`}</span>
                </button>
            </div>)}
            
            <div className="overflow-x-auto border border-neutral-200 rounded-xl">
                {(latest_flow_detail_id == undefined || 
                ((latest_flow_detail_id == "PURCHASE_REQUEST_DRAFT" || 
                latest_flow_detail_id == "PURCHASE_REQUEST_REJECTED") && 
                (is_admin == 1 || is_supervisor == 1 || is_owner == 1))
                || ((latest_flow_detail_id == "PURCHASE_REQUEST_NEED_REVIEW" || 
                latest_flow_detail_id == "PURCHASE_REQUEST_IN_REVIEW" ||
                latest_flow_detail_id == "PURCHASE_ORDER_REJECTED") && 
                (is_supervisor == 1 || is_owner == 1))
                || ((latest_flow_detail_id == "PURCHASE_REQUEST_APPROVED" || 
                latest_flow_detail_id == "PURCHASE_ORDER_IN_REVIEW") && is_owner == 1)) 
                && (
                <AddProduct onSubmit={() => {}} productUnitSelection={productUnitSelection} 
                    productItems = {data?.purchase_item_side_by_side} add={true}
                    purchase={{...arr_purchase, flow_detail_id,
                    latest_flow_detail_id }}/>)}
                <table className="min-w-full overflow-x-auto divide-y divide-neutral-200">
                    <thead className="bg-neutral-50 rounded-t-3xl">
                        <tr>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap"></th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap"></th>
                            {!(latest_flow_detail_id == "SALES_ORDER_APPROVED" || 
                            latest_flow_detail_id == "SALES_ORDER_BILL_CREATED" ||
                            latest_flow_detail_id == "SALES_ORDER_WILL_DELIVER" || 
                            latest_flow_detail_id == "SALES_ORDER_DELIVERY_ON_GOING" || 
                            latest_flow_detail_id == "SALES_ORDER_DELIVERY_RETURN"||
                            latest_flow_detail_id == "SALES_ORDER_BILL_RTN_CREATED"||
                            latest_flow_detail_id == "SALES_ORDER_CLOSED" ||
                            latest_flow_detail_id == "SALES_ORDER_BILL_PO_CREATED" ||
                            latest_flow_detail_id == "SALES_ORDER_COMPLETED") && (
                                <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap"></th>
                            )}
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap"></th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap"></th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap"></th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">PO Grand Amount</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">PO Grant Discount</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">PO Grand Nett</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap"></th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap"></th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">SO Grand Amount</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">SO Grant Discount</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">SO Grand Nett</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap"></th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">DLV Grand Nett</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap"></th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">RCV Grand Nett</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap"></th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">RTN Grand Nett</th>
                        </tr>
                    </thead>
                    <tr >
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap"/>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap"/>
                        {!(latest_flow_detail_id == "SALES_ORDER_APPROVED" || 
                            latest_flow_detail_id == "SALES_ORDER_BILL_CREATED" ||
                            latest_flow_detail_id == "SALES_ORDER_WILL_DELIVER" || 
                            latest_flow_detail_id == "SALES_ORDER_DELIVERY_ON_GOING" || 
                            latest_flow_detail_id == "SALES_ORDER_DELIVERY_RETURN"||
                            latest_flow_detail_id == "SALES_ORDER_BILL_RTN_CREATED"||
                            latest_flow_detail_id == "SALES_ORDER_CLOSED" ||
                            latest_flow_detail_id == "SALES_ORDER_BILL_PO_CREATED" ||
                            latest_flow_detail_id == "SALES_ORDER_COMPLETED") && (
                            <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap"/>
                        )}
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap"/>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap"/>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap"/>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                            {po_amount ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(po_amount) : '-'}
                        </td>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                            {po_discount_amount ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(po_discount_amount) : '-'}
                        </td>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                            {po_nett_amount ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(po_nett_amount) : '-'}
                        </td>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap"/>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap"/>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                            {so_amount ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(so_amount) : '-'}
                        </td>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                            {so_discount_amount ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(so_discount_amount) : '-'}
                        </td>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                            {so_nett_amount ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(so_nett_amount) : '-'}
                        </td>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap"/>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                            {dlv_nett_amount ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(dlv_nett_amount) : '-'}
                        </td>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap"/>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                            {rcv_nett_amount ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(rcv_nett_amount) : '-'}
                        </td>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap"/>
                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                            {rtn_nett_amount ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(rtn_nett_amount) : '-'}
                        </td>
                    </tr>
                    <thead className="bg-neutral-50 rounded-t-3xl">
                        <tr>
                            <th scope="col" className="relative px-6 py-3"><span className="sr-only">{lang.action}</span></th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">Type</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">Product Unit</th>
                            {/* {!(latest_flow_detail_id == "SALES_ORDER_APPROVED" || 
                            latest_flow_detail_id == "SALES_ORDER_BILL_CREATED" ||
                            latest_flow_detail_id == "SALES_ORDER_WILL_DELIVER" || 
                            latest_flow_detail_id == "SALES_ORDER_DELIVERY_ON_GOING" || 
                            latest_flow_detail_id == "SALES_ORDER_DELIVERY_RETURN"||
                            latest_flow_detail_id == "SALES_ORDER_BILL_RTN_CREATED"||
                            latest_flow_detail_id == "SALES_ORDER_CLOSED" ||
                            latest_flow_detail_id == "SALES_ORDER_BILL_PO_CREATED" ||
                            latest_flow_detail_id == "SALES_ORDER_COMPLETED") && (
                                <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">Supplier Stock</th>
                            )} */}
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">PO Qty</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">PO Price</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">PO Total Amount</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">PO Total Discount</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">PO Total Nett</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">SO Qty</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">SO Price</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">SO Total Amount</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">SO Total Discount</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">SO Total Nett</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">DLV Qty</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">DLV Total Nett</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">RCV Qty</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">RCV Total Nett</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">RTN Qty</th>
                            <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">RTN Total Nett</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-neutral-200">
                            {/* When loading */}
                            {isLoadingItem && (
                                <tr className="text-center">
                                    <td colSpan="10" className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {lang.loading_data}
                                    </td>
                                </tr>
                            )}

                            {/* When there are no list available */}
                            {data?.purchase_item?.length === 0 && !search && !isLoadingItem && (
                                <tr className="text-center">
                                    <td colSpan="10" className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {lang.no_data}
                                    </td>
                                </tr>
                            )}

                            {/* When there are no list available on searching */}
                            {data?.purchase_item?.length === 0 && search && !isLoadingItem && (
                                <tr className="text-center">
                                    <td colSpan="10" className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {lang.no_result}
                                    </td>
                                </tr>
                            )}

                            {data?.purchase_item_side_by_side?.length > 0 && data?.purchase_item_side_by_side?.map((row) => (
                                <tr key={row.id}>
                                    <td class="px-6 py-4 text-xs font-medium text-right whitespace-nowrap">
                                    {(((latest_flow_detail_id == undefined || 
                                        latest_flow_detail_id == "PURCHASE_REQUEST_DRAFT" || 
                                        latest_flow_detail_id == "PURCHASE_REQUEST_REJECTED") && 
                                        (is_admin == 1 || is_supervisor == 1 || is_owner == 1))
                                        || 
                                        ((latest_flow_detail_id == "PURCHASE_REQUEST_NEED_REVIEW" || 
                                        latest_flow_detail_id == "PURCHASE_REQUEST_IN_REVIEW" ||
                                        latest_flow_detail_id == "PURCHASE_ORDER_REJECTED") && 
                                        (is_supervisor == 1 || is_owner == 1))
                                        || 
                                        ((latest_flow_detail_id == "PURCHASE_REQUEST_APPROVED" || 
                                        latest_flow_detail_id == "PURCHASE_ORDER_IN_REVIEW") && is_owner == 1)
                                        ||
                                        ((latest_flow_detail_id == "SALES_ORDER_DELIVERY_ON_GOING" || latest_flow_detail_id == "SALES_ORDER_DELIVERY_RETURN") && is_admin == 1)
                                        )
                                        && ((latest_flow_detail_id !== "SALES_ORDER_DELIVERY_ON_GOING" && latest_flow_detail_id !== "SALES_ORDER_DELIVERY_RETURN") ? 
                                            row.item_type !== "GA" : true) 
                                        && (
                                        <div class="inline-flex items-center space-x-2">
                                            <AddProduct onSubmit={() => {}} productUnitSelection={productUnitSelection} 
                                                productItems = {data?.purchase_item_side_by_side} 
                                                item={row} add={false} 
                                                purchase={{...arr_purchase, flow_detail_id, latest_flow_detail_id }}/>
                                            {(latest_flow_detail_id !== "SALES_ORDER_DELIVERY_ON_GOING" && latest_flow_detail_id !== "SALES_ORDER_DELIVERY_RETURN") && 
                                            (<DeleteProduct onSubmit={() => {}} productUnitSelection={productUnitSelection} 
                                                productItems = {data?.purchase_item_side_by_side} 
                                                item={row} add={false} 
                                                purchase={{...arr_purchase, flow_detail_id, latest_flow_detail_id }}/>)}
                                        </div>)}
                                    </td>
                                    {row.item_type === "GA" ? (
                                        <td className="px-1 py-4 text-xs font-medium text-neutral-900 whitespace-nowrap">
                                            {"Give Away"}
                                        </td>) : (
                                        <td className="px-1 py-4 text-xs font-medium text-neutral-900 whitespace-nowrap">
                                            {"Order"}
                                        </td>)}
                                    <td className="px-1 py-4 text-xs font-medium text-neutral-900 whitespace-nowrap">
                                        {row.product_unit}
                                    </td>
                                    {/* {!(latest_flow_detail_id == "SALES_ORDER_APPROVED" || 
                                        latest_flow_detail_id == "SALES_ORDER_BILL_CREATED" ||
                                        latest_flow_detail_id == "SALES_ORDER_WILL_DELIVER" || 
                                        latest_flow_detail_id == "SALES_ORDER_DELIVERY_ON_GOING" || 
                                        latest_flow_detail_id == "SALES_ORDER_DELIVERY_RETURN"||
                                        latest_flow_detail_id == "SALES_ORDER_BILL_RTN_CREATED"||
                                        latest_flow_detail_id == "SALES_ORDER_CLOSED" ||
                                        latest_flow_detail_id == "SALES_ORDER_BILL_PO_CREATED" ||
                                        latest_flow_detail_id == "SALES_ORDER_COMPLETED") && (
                                        <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                            {row.pre_order == 0 ? row.current_stock : "PRE ORDER"}
                                        </td>
                                    )} */}
                                    <td className={`px-1 py-4 text-xs ${!(
                                        latest_flow_detail_id == "SALES_ORDER_APPROVED" || 
                                        latest_flow_detail_id == "SALES_ORDER_BILL_CREATED" ||
                                        latest_flow_detail_id == "SALES_ORDER_WILL_DELIVER" || 
                                        latest_flow_detail_id == "SALES_ORDER_DELIVERY_ON_GOING" || 
                                        latest_flow_detail_id == "SALES_ORDER_DELIVERY_RETURN"||
                                        latest_flow_detail_id == "SALES_ORDER_BILL_RTN_CREATED"||
                                        latest_flow_detail_id == "SALES_ORDER_CLOSED" ||
                                        latest_flow_detail_id == "SALES_ORDER_BILL_PO_CREATED" ||
                                        latest_flow_detail_id == "SALES_ORDER_COMPLETED") && (row.po_quantity > row.current_stock && row.pre_order == 0) ? 'text-neutral-500' : 'text-neutral-500'}  whitespace-nowrap`}>
                                        {row.po_quantity}
                                    </td>
                                    <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {row.po_price ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(row.po_price) : '-'}
                                    </td>
                                    <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {row.po_total_amount ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(row.po_total_amount) : '-'}
                                    </td>
                                    <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {row.po_total_discount ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(row.po_total_discount) : '-'}
                                    </td>
                                    <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {row.po_total_nett ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(row.po_total_nett) : '-'}
                                    </td>
                                    <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {row.so_quantity}
                                    </td>
                                    <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {row.so_price ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(row.so_price) : '-'}
                                    </td>
                                    <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {row.so_total_amount ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(row.so_total_amount) : '-'}
                                    </td>
                                    <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {row.so_total_discount ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(row.so_total_discount) : '-'}
                                    </td>
                                    <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {row.so_total_nett ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(row.so_total_nett) : '-'}
                                    </td>
                                    <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {row.dlv_quantity}
                                    </td>
                                    <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {row.dlv_total_nett ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(row.dlv_total_nett) : '-'}
                                    </td>
                                    <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {row.rcv_quantity}
                                    </td>
                                    <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {row.rcv_total_nett ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(row.rcv_total_nett) : '-'}
                                    </td>
                                    <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {row.rtn_quantity}
                                    </td>
                                    <td className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {row.rtn_total_nett ? Intl.NumberFormat('id-Id', { style: 'currency', currency: 'idr' }).format(row.rtn_total_nett) : '-'}
                                    </td>
                                    
                                </tr>
                            ))}
                        </tbody>
                </table>
            </div>

            {(((latest_flow_detail_id == undefined || 
                latest_flow_detail_id == "PURCHASE_REQUEST_DRAFT" || 
                latest_flow_detail_id == "PURCHASE_REQUEST_REJECTED") && 
                (is_admin == 1 || is_supervisor == 1 || is_owner == 1))
                || 
                ((latest_flow_detail_id == "PURCHASE_REQUEST_NEED_REVIEW" || 
                latest_flow_detail_id == "PURCHASE_REQUEST_IN_REVIEW" ||
                latest_flow_detail_id == "PURCHASE_ORDER_REJECTED") && 
                (is_supervisor == 1 || is_owner == 1))
                || 
                ((latest_flow_detail_id == "PURCHASE_REQUEST_APPROVED" || 
                latest_flow_detail_id == "PURCHASE_ORDER_IN_REVIEW") && is_owner == 1)
                ||
                ((latest_flow_detail_id == "SALES_ORDER_DELIVERY_ON_GOING" || latest_flow_detail_id == "SALES_ORDER_DELIVERY_RETURN") && is_admin == 1)
                )
                && (
            <div className="mt-8 text-xs text-right">
                <button onClick={handleSubmit} className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90">
                    <span>{`${lang.save}`}</span>
                </button>
            </div>)}
        </div>
    )
}